export default __webpack_public_path__ + "static/media/_bg-test.4f4a1e67.jpeg";